module.exports = __webpack_public_path__ + "img/empty.a440b734.svg";